import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";

import "moment-timezone";

import {
    setLoading as setTboHotelLoading,
    setTboHotels,
    setError,
} from "../../features/common/tboHotelSlice";
import { deletePackageById, tboHotelList , updateTboHotelPrimaryImage } from "../../services/userservice";
import "./HotelTable.css";
import SearchableDropdownCity from './../common/SearchableDropdownCity';

const TboHotelList = () => {
    const [currentPage, setCurrentPage] = useState(1);
        const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const { hotels, loading, error } = useSelector((state) => state?.tboHotel ?? { hotels: [], loading: false, error: null });
    const [showModal, setShowModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const dispatch = useDispatch();
    const [primaryImages, setPrimaryImages] = useState({});

    const handlePrimaryImageChange = async (hotelId, imageUrl) => {
        setPrimaryImages((prev) => ({ ...prev, [hotelId]: imageUrl }));
        try {
            const formDataToSend = {
                id: hotelId,
                url: imageUrl
            };
            await updateTboHotelPrimaryImage(formDataToSend);
            console.log(`Primary image updated for hotel ${hotelId}`);
        } catch (error) {
            console.error("Failed to update primary image:", error);
        }
    };

    useEffect(() => {
        const fetchTboHotelData = async () => {
            try {
                dispatch(setTboHotelLoading(true));
                const response = await tboHotelList(130443);
                dispatch(setTboHotels(response?.data?.data || []));
            } catch (error) {
                dispatch(setError(error.message));
            } finally {
                dispatch(setTboHotelLoading(false));
            }
        };
        fetchTboHotelData();
    }, [dispatch]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value)
        setCurrentPage(1)
    };
    const filteredHotels = hotels.filter(
        (hotel) =>
            hotel?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            hotel?.tboCityName?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;



    const handleDelete = async () => {
        try {
            const deleteResponse = await deletePackageById(selectedUserId);
            if (deleteResponse.status === 200 || deleteResponse.status === 201) {
                //setDeleteUser(selectedUserId);
                closeModal();
            } else {
                setError(deleteResponse.message || "Failed to delete user");
            }
        } catch (error) {
            alert("You are not authorized to delete this user");
        }
    };



    const openModal = (userId) => {
        setSelectedUserId(userId);
        setShowModal(true);
    };


    const closeModal = () => {
        setShowModal(false);
    };


    const confirmDelete = async () => {
        await handleDelete(selectedUserId);
        closeModal();
    };
    const fetchTboHotelData = async (id) => {
        try {
            dispatch(setTboHotelLoading(true));
            const response = await tboHotelList(id);
            dispatch(setTboHotels(response?.data?.data || []));
        } catch (error) {
            dispatch(setError(error.message));
        } finally {
            dispatch(setTboHotelLoading(false));
        }
    };
    const handleCitySelect = (city) => {
        fetchTboHotelData(city?.value);
    };


     // Table rows to show per page Start

     const indexOfLastPackage = currentPage * rowsPerPage;
     const indexOfFirstPackage = indexOfLastPackage - rowsPerPage;
     const currentPackages = filteredHotels.slice(indexOfFirstPackage, indexOfLastPackage);
 
     // bottom pagination start
 
     const totalPages = Math.ceil(filteredHotels.length / rowsPerPage);
 
     const renderPageNumbers = () => {
         const pages = [];
         const maxPagesToShow = 3;
 
         if (totalPages <= 10) {
             for (let i = 1; i <= totalPages; i++) {
                 pages.push(i);
             }
         } else {
             // Always show first 3 pages
             pages.push(1, 2, 3);
 
             // Show "..." if currentPage is beyond 5
             if (currentPage > 5) {
                 pages.push("...");
             }
 
             // Show current page and neighbors
             const start = Math.max(4, currentPage - 1);
             const end = Math.min(totalPages - 3, currentPage + 1);
 
             for (let i = start; i <= end; i++) {
                 if (!pages.includes(i)) pages.push(i);
             }
 
             // Show "..." if currentPage is far from end
             if (currentPage < totalPages - 4) {
                 pages.push("...");
             }
 
             // Always show last 3 pages
             pages.push(totalPages - 2, totalPages - 1, totalPages);
         }
 
         return pages.map((page, index) => (
             <li
                 key={index}
                 className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
             >
                 {page === "..." ? (
                     <span className="page-link">...</span>
                 ) : (
                     <button className="page-link" onClick={() => setCurrentPage(page)}>
                         {page}
                     </button>
                 )}
             </li>
         ));
     };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">TBO Hotels</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Packages</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                            <div className="card-header">
                                <div className="d-md-flex align-items-center justify-content-end">
                                <div style={{ position: "relative", zIndex: 1051 }}><SearchableDropdownCity onSelect={handleCitySelect}/></div>
                                    <div className="card-tools">
                                        <div
                                            className="input-group input-group-sm"
                                            style={{ width: "250px" }}
                                        >
                                            <input
                                                type="text"
                                                name="table_search"
                                                className="form-control float-right"
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                                style={{ height: 38, marginLeft:10 }}
                                            />
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-default">
                                                    <i className="fas fa-search" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div className="card-body">
                                    
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responisve">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                <th className="fixed-column-index">ID</th>
                                                <th className="fixed-column">Name</th>
                                                <th className="fixed-column">City Name</th>
                                                <th className="scrollable-column">Images</th>
                                                </tr>
                                            </thead>
                                            {currentPackages.length > 0 ? (
                                                <tbody>
                                                    {currentPackages.map((hotel) => {
                                                        const images = hotel?.images ? JSON.parse(hotel?.images) : [];
                                                        //const parsedImages = JSON.parse(images) // it is required in local

                                                        const renderImageCell = (imageUrl, hotelId, primary_image) => (
                                                            imageUrl ? (
                                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                    <img 
                                                                        src={imageUrl} 
                                                                        style={{ width: "auto", height: "65px", borderRadius: "5px" }}
                                                                    />
                                                                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                                                        <input 
                                                                            type="radio" 
                                                                            name={`primary-image-${hotelId}`} 
                                                                            checked={primaryImages[hotelId] === imageUrl || primary_image === imageUrl}
                                                                            onChange={() => handlePrimaryImageChange(hotelId, imageUrl)}
                                                                            style={{ marginRight: "5px" , cursor: "pointer"}}
                                                                        />
                                                                        <label style={{ fontSize: "12px" }}>
                                                                            Mark Primary
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <span>No Image Available</span>
                                                            )
                                                        );

                                                        return (
                                                            <tr key={hotel.id}>
                                                                <td className="fixed-column-index">{hotel.id}</td>
                                                                <td className="fixed-column">{hotel.name}</td>
                                                                <td className="fixed-column">{hotel.tboCityName}</td>
                                                                <td className="scrollable-column">
                                                                    <div className="image-container">
                                                                        {
                                                                        images?.map && images.map((image, index) => (
                                                                            <div key={index} className="image-box">
                                                                                {renderImageCell(image, hotel.id, hotel.primary_image)}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="4" className="text-center">No Hotel found</td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                    
                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstPackage + 1} to {Math.min(indexOfLastPackage, filteredHotels.length)} of {filteredHotels.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-4">
                        <h5>Are you sure you want to delete this Package?</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirmDelete}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default TboHotelList;
